export default __webpack_public_path__ + "static/media/wedding-cake.b0928f18.jpg";